







import { defineComponent, PropType } from "@vue/composition-api";
import { format, parseISO } from "date-fns";
import { Announcement } from "@scrile/api-provider/dist/api/AnnouncementsProvider";
import WysiwygViewer from "@/components/WysiwygViewer";

export default defineComponent({
  name: "PageAnnouncementItem",
  components: { WysiwygViewer },
  props: {
    announcement: { type: Object as PropType<Announcement>, required: true },
  },
  setup(props) {
    const time = format(parseISO(props.announcement.time), "hh:mm a");
    return {
      time,
    };
  },
});
